import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'

import { layout, colors } from 'Constants'

import { Flex } from 'lese'
import { ActiveLink } from 'raviger'
import { cookiesToObject } from 'Helpers'

import request from 'Request'
import { downloadText } from 'Root/helpers'

const Nav = styled(Flex)`
  box-sizing: border-box;
  padding: 16px;
  margin: auto;

  * + * {
    margin-left: 36px;
  }

  @media print {
    display: none;
  }
`.withComponent('nav')

const Link = styled(ActiveLink)`
  color: ${colors.text};
  text-decoration: none;
  transition: 0.2s color;

  &.active {
    color: ${colors.textPrimary};
  }

  ${({ disabled }) =>
    disabled && `color: ${colors.textInverted}; pointer-events: none;`};
`
Link.defaultProps = { exactActiveClass: 'active' }

export default () => {
  const [user, setUser] = useState('Loading...')

  // TODO: Cache result or only run once unless logged out
  useEffect(() => request('/auth/get').then(res => setUser(res.data)), [])

  const cookies = cookiesToObject(document.cookie)
  return (
    <header style={{ backgroundColor: colors.background600 }}>
      <Nav xAlign="stretch" yAlign width={layout.maxWidth} responsive>
        <Link href="/">
          <img src="/logo.png" />
        </Link>
        <Link href="/">Home</Link>
        <Link href="/activity">Activity</Link>
        <Link href="/device">Device</Link>
        <Link href="/archive">Archive</Link>
        <Link href="/message">Message</Link>
        <Link href="/alerts">Alerts</Link>

        {cookies.loggedIn === 'true' ? (
          <>
            <Link
              onClick={() => request('/auth/logout')}
              href="/login"
              style={{ marginLeft: 'auto' }}
            >
              Logout
            </Link>
            <span>{user && user.username}</span>
          </>
        ) : (
          <Link href="/login" style={{ marginLeft: 'auto' }}>
            Login
          </Link>
        )}
      </Nav>
    </header>
  )
}
